import classNames from 'classnames';
import { LocationFilledIcon, LocationIcon } from 'app/agriculture/icons';
import { TaskPriority } from 'app/agriculture/queries/tasks/types/TaskPriority';
import './TaskLocationIcon.scss';

interface TaskLocationIconProps {
    isAssignedToActiveUser?: boolean;
    isOverdue?: boolean;
    priority: TaskPriority;
    size: number;
}

export function TaskLocationIcon({
    priority,
    size,
    isOverdue = false,
    isAssignedToActiveUser = false,
}: TaskLocationIconProps) {
    return (
        <div
            className={classNames(
                'TaskLocationIcon',
                `TaskLocationIcon--${priority.toLowerCase()}-priority`,
                {
                    'TaskLocationIcon--overdue': isOverdue,
                    'TaskLocationIcon--assigned-to-you': isAssignedToActiveUser,
                },
            )}
        >
            {isAssignedToActiveUser ? (
                <LocationFilledIcon size={size} />
            ) : (
                <LocationIcon size={size} />
            )}
        </div>
    );
}
